module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hamvqJ/tc-custom/9780062374295.jpg?1731411144049",
      "alt": "This image is the cover for the book Teacher's Guide for a Prayer for Owen Meany"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Teacher's Guide for a Prayer for Owen Meany\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("For teachers")]), _c('p', [_vm._v("We know that the Common Core State Standards are encouraging you to reevaluate the books that you assign to your students. To help you decide which books are right for your classroom, each free ebook in this series contains a Common Core–aligned teaching guide and a sample chapter.")]), _c('p', [_vm._v("This free teaching guide for "), _c('i', [_vm._v("A Prayer for Owen Meany")]), _vm._v(" by John Irving is designed to help you put the new Common Core State Standards into practice.")]), _c('p', [_vm._v("\"Among the very best American novels of our time.\"—"), _c('i', [_vm._v("Charlotte Observer")])]), _c('p', [_vm._v("In the summer of 1953, two eleven-year-old boys—best friends—are playing in a Little League baseball game in Gravesend, New Hampshire. One of the boys hits a foul ball that kills the other boy's mother. The boy who hits the ball doesn't believe in accidents; Owen Meany believes he is God's instrument. What happens to Owen after that 1953 foul ball is extraordinary.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Irving, Amy Jurskis\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollinsPublishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0